import React from 'react';
import styles from './HeroSection.module.css';

// No default import here — image is passed as a prop from each page

const HeroSection = ({ title = "Our Story", image, imageAlt = "" }) => {
  return (
    <section className={styles.hero}>

      {/* Background Image & Overlay */}
      <div className={styles.backgroundWrapper}>
        {image && (
          <img
            src={image}
            alt={imageAlt}
            className={styles.backgroundImage}
          />
        )}
        <div className={styles.overlay} />
      </div>

      {/* Center Content */}
      <div className={styles.content}>
        <h1 className={styles.title}>{title}</h1>
      </div>

    </section>
  );
};

export default HeroSection;